<template>
  <div class="wrapper form-group">
    <webshipper-input-label
      :label="label"
      :value="value"
      :default_value="default_value"
      @revert="update_value($event)"
    ></webshipper-input-label>
    <div class="input-group">
      <div class="d-flex w-100">
        <input
          class="form-control"
          :value="value"
          :readonly="readonly"
          @input="(e) => $emit('input', e.target.value)"
        />
        <div class="input-group-append">
          <webshipper-input-revert
            v-if="can_revert && !readonly && default_value"
            :value="value"
            :default_value="default_value"
            @revert="update_value($event)"
            :appended="true"
          ></webshipper-input-revert>
        </div>
      </div>
      <span class="form-text text-muted" v-if="help_text">{{ help_text | t }}</span>
    </div>
  </div>
</template><script>
export default {
  props: {
    value: {
      type: String | null,
      required: true
    },
    default_value: {
      type: String | null,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false
    },
    liquids: {
      type: Array | null,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    can_revert: {
      type: Boolean,
      required: false,
      default: false
    },
    usePlaceholders: {
      type: Boolean,
      required: false,
      default: false
    },
    help_text: {
      type: String | null,
      required: false,
      default: null
    }
  },
  methods: {
    update_value(event) {
      this.$emit('input', event);
    }
  }
};
</script>
